import { useAuth0 } from '@auth0/auth0-react';
import { useSearchParams } from 'react-router-dom';

import { authErrorCopy } from './auth-error-copy';

export default function AuthErrorPage() {
  const [params] = useSearchParams();
  const { logout, isAuthenticated } = useAuth0();
  const error = params.get('error') ?? 'unknown_error';
  const errorDescription = params.get('error_description') ?? 'An unexpected error occurred.';
  const isAccessDenied = error === 'access_denied';
  const copy = authErrorCopy(error, errorDescription);

  return (
    <div className="min-h-screen flex items-center justify-center bg-page">
      <div className="text-center max-w-md px-6">
        <h1 className="text-4xl font-bold text-bark-900 dark:text-stone-100 mb-4">
          {copy.heading}
        </h1>
        <p className="text-stone-600 dark:text-stone-400 mb-2">{errorDescription}</p>
        {copy.hint && (
          <p className="text-sm text-stone-600 dark:text-stone-400 mb-2">{copy.hint}</p>
        )}
        <p className="text-xs text-stone-400 dark:text-stone-500 font-mono mb-6">{error}</p>
        <div className="flex items-center justify-center gap-4">
          {copy.canRetry && (
            <a href="/" className="text-moss-600 hover:text-moss-700 text-sm">
              Try again
            </a>
          )}
          {(isAccessDenied || isAuthenticated) && (
            <button
              onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
              className="text-sm text-red-600 dark:text-red-400 hover:underline"
            >
              Sign out
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
